export const SHOW_SNACKBAR = "SHOW_SNACKBAR";
export const HIDE_SNACKBAR = "HIDE_SNACKBAR";
export const SHOW_MODAL_WARNING = "SHOW_MODAL_WARNING";
export const HIDE_MODAL_WARNING = "HIDE_MODAL_WARNING";
export const ADD_GROUP_REF = "ADD_GROUP_REF";
export const ADD_GROUP_REF_WITH_MSG = "ADD_GROUP_REF_WITH_MSG";
